import { create } from "zustand";
import { persist } from "zustand/middleware";

export const THEME_PREFERENCES = ["system", "light", "dark"] as const;

export type ThemePreference = (typeof THEME_PREFERENCES)[number];
export type ResolvedTheme = Exclude<ThemePreference, "system">;

export const THEME_STORAGE_KEY = "themeStore";

export type ThemeStoreState = {
  preference: ThemePreference;
  resolvedTheme: ResolvedTheme;
  setPreference: (preference: ThemePreference) => void;
  setResolvedTheme: (resolvedTheme: ResolvedTheme) => void;
};

export const useThemeStore = create<ThemeStoreState>()(
  persist(
    (set) => {
      return {
        preference: "system",
        resolvedTheme: "light",
        setPreference: (preference: ThemePreference) => {
          set(() => {
            return { preference };
          });
        },
        setResolvedTheme: (resolvedTheme: ResolvedTheme) => {
          set(() => {
            return { resolvedTheme };
          });
        },
      };
    },
    {
      name: THEME_STORAGE_KEY,
      partialize: (state) => {
        return { preference: state.preference };
      },
    },
  ),
);

export const getThemeStoreState = () => {
  return useThemeStore.getState();
};
